import React from 'react'
import PropTypes from 'prop-types'

import Form from '../../../../common/formComponents/Form'
import FormElement from '../../../../common/formComponents/FormElement'
import AutoCompleter from '../../../../common/formComponents/AutoCompleter'
import withPolyglot from '../../../../common/withPolyglot'
import moment from 'moment'
import { INSERTION_TYPE } from '../../../../../resources/utilities'

class ImmunizationInsertion extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeMedicines: [],
      activePathologies: props.selectedPathology ? [props.selectedPathology] : [],
      hasAdverseReaction: false,
      adverseReaction: {}
    }
    this.getLots = this.getLots.bind(this)
  }

  componentDidMount () {
    this.setState({
      activeMedicines: this.getMedicines(this.props.insertionType)
    }, () => {
      if (this.props.selectedPathology) {
        this.filterMedicinesByPathologies([this.props.selectedPathology])
      }
    })
  }

  getMedicines (type) {
    const res = []
    if (type === INSERTION_TYPE.PREVIOUS) {
      this.props.availableMedicines.forEach(medicine => {
        if (medicine.type === INSERTION_TYPE.VACCINE) {
          res.push(medicine)
        }
      })
    } else {
      this.props.availableMedicines.forEach(medicine => {
        if (medicine.type === type) {
          res.push(medicine)
        }
      })
    }
    return res
  }

  filterMedicinesByPathologies (pathologies) {
    const result = []
    this.state.activeMedicines.forEach(medicine => {
      pathologies.forEach(pathologyId => {
        if (medicine.targetDiseases.includes(pathologyId)) {
          if (!result.includes(medicine)) {
            result.push(medicine)
          }
        }
      })
    })
    this.setState({
      activeMedicines: result
    })
  }

  getLots () {
    if (this.state.selectedMedicine) {
      const arr = []
      this.state.selectedMedicine.lots.forEach(lot => arr.push({value: lot, displayValue: lot}))
      return arr
    } else {
      return []
    }
  }

  removePathology (pathologyId) {
    const {activePathologies} = this.state
    const filtered = activePathologies.filter(pathology => pathology !== pathologyId)
    this.setState({
      activePathologies: filtered
    }, () => {
      this.filterMedicinesByPathologies(filtered)
      if (this.state.activePathologies.length === 0) {
        this.setState({
          activeMedicines: this.getMedicines(this.props.insertionType)
        })
      }
    })
  }

  replacePathologies (pathologies) {
    const arr = []
    pathologies.forEach(pathology => arr.push(pathology))
    this.setState({
      activePathologies: arr
    })
  }

  addPathology (pathology) {
    const pathologies = this.state.activePathologies
    pathologies.push(pathology.id)
    this.setState({
      activePathologies: pathologies,
      listInputActive: false
    }, this.filterMedicinesByPathologies(pathologies))
  }

  handleMedicineChange (_, value) {
    const medicine = this.props.availableMedicines.find(med => med.code === value)
    this.replacePathologies(medicine.targetDiseases)
    this.setState({
      selectedMedicine: medicine
    })
  }

  getPathologyFromDisplayKey (key) {
    return this.props.availablePathologies.find(pathology => pathology.displayKey === key)
  }

  getPathologiesForList (pathologies = []) {
    const arr = []
    const available = this.props.availablePathologies
    pathologies.forEach(pathologyId => {
      const pathology = available.find(p => p.id === pathologyId)
      arr.push({value: pathology.id, displayValue: this.props.translate(pathology.displayKey, true, 'pathologies')})
    })
    return arr
  }

  getPathologiesForAutocomplete () {
    const arr = []
    this.props.availablePathologies.forEach(pathology => arr.push({
      displayValue: this.props.translate(pathology.displayKey, true, 'pathologies'),
      key: pathology.displayKey
    }))
    return arr
  }

  getMedicinesForSelect () {
    const arr = []
    this.state.activeMedicines.forEach(medicine => arr.push({value: medicine.code, displayValue: medicine.name}))
    arr.sort((a, b) => {
      const nameA = a.displayValue.toUpperCase()
      const nameB = b.displayValue.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    return arr
  }

  submitForms () {
    const immunizationForm = this.refs['immunizationForm']
    const adverseReactionForm = this.refs['adverseReactionForm'].state
    if (Object.keys(immunizationForm.state).length < 4) {
      immunizationForm.submitForm()
    } else {
      console.log(immunizationForm.state)
      console.log(adverseReactionForm.state)
    }
  }

  handleSubmit (content) {
    const adverseReactionData = {}
    const immunizationData = {}
    Object.keys(content).forEach((key) => {
      if (key.split('-').length > 1) {
        const name = key.split('-')[1]
        adverseReactionData[name] = content[key]
      } else {
        immunizationData[key] = content[key]
      }
    })
    this.props.handleSubmit(immunizationData, adverseReactionData)
  }

  handlePreviousImmunizationSubmit (content) {
    const immunizationData = {}
    Object.keys(content).forEach((key) => {
      immunizationData[key] = content[key]
    })
    this.props.handlePreviousImmunizationSubmit(immunizationData)
  }

  immunizationItems () {
    const {translate} = this.props
    return [
      <FormElement
        key={'pathologies-input'}
        type={'list'}
        label={translate('pathologies')}
        name={'pathologies'}
        options={this.getPathologiesForList(this.state.activePathologies)}
        withEdit
        isInputInFocus={this.state.listInputActive || false}
        focusInput={() => { this.setState({listInputActive: true}) }}
        innerField={
          <AutoCompleter
            autoFocus
            name={'pathologiesSelect'}
            onSuggestionSelected={(element) => { this.addPathology(this.getPathologyFromDisplayKey(element.suggestion.key)) }}
            options={this.getPathologiesForAutocomplete()}
            minChar={0} />}
        removeElement={this.removePathology.bind(this)} />,
      <FormElement
        key={'medicine-input'}
        required
        handleChange={this.handleMedicineChange.bind(this)}
        type={'select'}
        label={this.props.insertionType === INSERTION_TYPE.VACCINE ? translate('vaccine') : translate('immunoglobulin')}
        name={'medicine'}
        options={this.getMedicinesForSelect()} />,
      <FormElement
        key={'lot-input'}
        required
        disabled={!this.state.selectedMedicine}
        type={'select'}
        label={translate('batch')}
        name={'lot'}
        options={this.getLots()} />,
      <FormElement
        key={'observations-input'}
        type={'textarea'}
        label={translate('observations')}
        name={'observations'}
        placeholder={translate('observationsPlaceholder')} />,
      <FormElement
        key={'adverseReaction-input'}
        handleChange={(_, value) => {
          if (value === 'positive') {
            window.alert(translate('adverseReactionAttentionMessage'))
          }
          this.setState({hasAdverseReaction: value === 'positive'})
        }}
        required
        type={'radio'}
        label={translate('adverseReaction')}
        name={'adverseReaction'}
        options={[
          {value: 'positive', displayValue: translate('positiveAnswer')},
          {value: 'negative', displayValue: translate('negativeAnswer')}]} />
    ]
  }

  previousImmunizationItems () {
    const {translate, patientBirthDate} = this.props
    return [
      <FormElement
        key={'date-input'}
        required
        minValue={moment(new Date(patientBirthDate)).format('YYYY-MM-DD')}
        maxValue={moment(new Date()).format('YYYY-MM-DD')}
        type={'date'}
        label={'Date'}
        name={'date'} />,
      <FormElement
        key={'pathologies-input'}
        type={'list'}
        required
        label={translate('pathologies')}
        name={'pathologies'}
        options={this.getPathologiesForList(this.state.activePathologies)}
        withEdit
        isInputInFocus={this.state.listInputActive || false}
        focusInput={() => { this.setState({listInputActive: true}) }}
        innerField={
          <AutoCompleter
            autoFocus
            required
            name={'pathologiesSelect'}
            onSuggestionSelected={(element) => { this.addPathology(this.getPathologyFromDisplayKey(element.suggestion.key)) }}
            options={this.getPathologiesForAutocomplete()}
            minChar={0} />}
        removeElement={this.removePathology.bind(this)} />,
      <FormElement
        key={'medicine-input'}
        required
        handleChange={this.handleMedicineChange.bind(this)}
        type={'select'}
        label={translate('vaccine')}
        name={'medicine'}
        options={this.getMedicinesForSelect()} />,
      <FormElement
        key={'lot-input'}
        required
        disabled={!this.state.selectedMedicine}
        type={'select'}
        label={translate('batch')}
        name={'lot'}
        options={this.getLots()} />,
      <FormElement
        key={'observations-input'}
        type={'textarea'}
        label={translate('observations')}
        name={'observations'}
        placeholder={translate('observationsPlaceholder')} />
    ]
  }

  adverseReactionItems () {
    const {translate} = this.props
    return [
      <FormElement key={'adverseReactionDescription'} type={'text'} label={translate('description')} name={'adverseReaction-description'}
        placeholder={translate('descriptionPlaceholder')} />,
      <FormElement required key={'adverseReactionStartDate'} type={'date'} label={translate('start')} name={'adverseReaction-startDate'} />,
      <FormElement required key={'adverseReactionEndDate'} type={'date'} label={translate('end')} name={'adverseReaction-endDate'} />,
      <hr key={'separator'} />,
      <FormElement
        required
        key={'adverseReactionType'}
        type={'checkbox'}
        label={translate('reactionType')}
        name={'adverseReaction-type'}
        options={[
          {value: 'lifeInRisc', displayValue: translate('lifeInRisc')},
          {value: 'congenitalAnomalies', displayValue: translate('congenitalAnomalies')},
          {
            value: 'motivatedOrProlongedHospitalization',
            displayValue: translate('motivatedOrProlongedHospitalization')
          },
          {value: 'significantIncapacities', displayValue: translate('significantIncapacities')},
          {value: 'death', displayValue: translate('death')},
          {value: 'other', displayValue: translate('other')}
        ]} />,
      <FormElement key={'adverseReactionDescriptionOfType'} type={'text'} label={translate('description')} name={'adverseReaction-descriptionOfType'} />,
      <FormElement
        required
        key={'adverseReactionDetailsOfReaction'}
        type={'checkbox'}
        label={translate('reactionDetails')}
        name={'adverseReaction-detailsOfReaction'}
        options={[
          {value: 'suspendedDueToReaction', displayValue: translate('suspendedDueToReaction')},
          {value: 'improvedAfterSuspension', displayValue: translate('improvedAfterSuspension')},
          {value: 'noChange', displayValue: translate('noChange')},
          {value: 'reductionOfPosology', displayValue: translate('reductionOfPosology')},
          {value: 'reactionSuspitionBetweenDrugs', displayValue: translate('reactionSuspitionBetweenDrugs')},
          {value: 'reintroduced', displayValue: translate('reintroduced')},
          {value: 'sameReactionAfterReintroduction', displayValue: translate('sameReactionAfterReintroduction')},
          {value: 'previousReactionToSameVaccine', displayValue: translate('previousReactionToSameVaccine')},
          {value: 'previousReactionToOtherDrugs', displayValue: translate('previousReactionToOtherDrugs')}
        ]} />,
      <FormElement
        required
        key={'adverseReactionCasualityRelation'}
        type={'radio'}
        label={translate('casualityRelation')}
        name={'adverseReaction-casualityRelation'}
        options={[
          {value: 'definitive', displayValue: translate('definitive')},
          {value: 'probable', displayValue: translate('probable')},
          {value: 'possible', displayValue: translate('possible')},
          {value: 'unlikely', displayValue: translate('unlikely')}
        ]} />
    ]
  }

  render () {
    const {translate, insertionType} = this.props
    if (insertionType === INSERTION_TYPE.PREVIOUS) {
      return <div>
        <Form ref={'immunizationForm'} handleSubmit={this.handlePreviousImmunizationSubmit.bind(this)}>
          {this.previousImmunizationItems()}
          <button
            className='uk-button uk-button-primary uk-align-right uk-margin-small'
            type='submit'>{translate('submit')}</button>
        </Form>
      </div>
    } else {
      return <div>
        <Form ref={'immunizationForm'} handleSubmit={this.handleSubmit.bind(this)}>
          {this.immunizationItems()}
          <hr />
          {this.state.hasAdverseReaction
            ? this.adverseReactionItems()
            : <div />
          }
          <button
            className='uk-button uk-button-primary uk-align-right uk-margin-small'
            type='submit'>{translate('submit')}</button>
        </Form>
      </div>
    }
  }
}

ImmunizationInsertion.propTypes = {
  availablePathologies: PropTypes.array.isRequired,
  availableMedicines: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handlePreviousImmunizationSubmit: PropTypes.func.isRequired,
  insertionType: PropTypes.oneOf([INSERTION_TYPE.IMMUNOGLOBULIN, INSERTION_TYPE.VACCINE, INSERTION_TYPE.PREVIOUS]).isRequired,
  selectedPathology: PropTypes.string,
  patientBirthDate: PropTypes.string,
  selectedRecommendation: PropTypes.object
}

export default withPolyglot(ImmunizationInsertion, 'immunizationInsertion')
